import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
})
export class FilterComponent {
  @Input({ required: true }) filterBy!: string;
  @Input({ required: true }) filterByOptions!: {
    option: string;
    value: string;
  }[];
  @Input() label = 'Filter by:';
  @Input() disabled = false;
  @Input() disabledTooltip = '';

  @Output() filterByChanged = new EventEmitter<string>();

  onFilterChange(event: Event): void {
    const { value } = event.target as HTMLInputElement;
    this.filterBy = value;
    this.filterByChanged.emit(value);
  }
}
